export const SERVICE_TYPES = {
  FREE_MOUNTING_BALANCING: "FREE_MOUNTING_BALANCING",
  INSTALL_IT_FOR_ME: "INSTALL_IT_FOR_ME",
};

export const PAGE_TYPES = {
  ALL_MAKES_PAGE: "ALL_MAKES_PAGE",
  MAKE_PAGE: "MAKE_PAGE",
  MAKE_MODEL_PAGE: "MAKE_MODEL_PAGE", // https://partsavatar.ca/honda-civic-parts
  YEAR_MAKE_MODEL_PAGE: "YEAR_MAKE_MODEL_PAGE", // https://partsavatar.ca/2011-honda-civic-parts

  PRODUCT: "PRODUCT_PAGE",
  PRODUCT_FITMENT: "PRODUCT_FITMENT_PAGE", //
  // /2008-ford-f150-serpentine-belt-gates-k060966
  // /2008-ford-f150-serpentine-belt-gates-k060966
  // /2008-ford-f250-super-duty-caster-camber-adjusting-kit-mevotech-mk8986
  // /1980-ford-l-series-new-master-cylinder-raybestos-mc39335
  // /2009-dodge-durango-hybrid-rear-turn-signal-wagner-3057
  // /2001-ford-windstar-front-right-hand-thread-wheel-nut-dorman-autograde-611-063bp
  // /2004-suzuki-xl7-backup-light-putco-lighting-237440a360
  // /2016-dodge-ram-1500-running-board-or-boards-westin-27-0010
  // /1979-cadillac-commercial-chassis-electric-fuel-pump-delphi-fd0011
  // /1991-cadillac-allante-under-hood-light-wagner-906
  // /1999-mercedes-benz-cl500-double-platinum-plug-champion-spark-plug-7318
  PRODUCT_MAKE_MODEL_PAGE: "PRODUCT_MAKE_MODEL_PAGE",
  // 2006-2011-ford-ranger-fender-liner-fo1248109
  // /2016-2017-ford-police-interceptor-utility-rear-semi-metallic-pads-agna-brakes-ald1612m
  // /2007-2013-bmw-328-series-remanufactured-alternator-remy-12891
  // /2007-2011-bmw-323-series-remanufactured-alternator-remy-12891
  // /2008-2010-bmw-528i-ia-remanufactured-alternator-remy-12891
  // /2002-2004-infiniti-i35-front-semi-metallic-pads-agna-brakes-ald815am
  // /2002-2003-nissan-maxima-front-semi-metallic-pads-agna-brakes-ald815am
  // /2007-2012-nissan-versa-front-semi-metallic-pads-agna-brakes-ald815am
  // /2011-2014-nissan-cube-front-semi-metallic-pads-agna-brakes-ald815am
  // /2015-2017-nissan-juke-front-semi-metallic-pads-agna-brakes-ald815am
  // /2002-2006-nissan-altima-front-semi-metallic-pads-agna-brakes-ald815am
  // /2009-2013-suzuki-sx4-front-semi-metallic-pads-agna-brakes-ald815am
  // /2019-2020-dodge-ram-classic-rear-premium-ceramic-pads-wagner-oex967a
  // /1994-1997-mercury-cougar-oil-filter-adapter-gasket-fel-pro-es73132
  // /2001-2002-qvale-mangusta-oil-filter-adapter-gasket-fel-pro-es73132
  // /1992-1993-mercury-full-size-mercury-oil-filter-adapter-gasket-fel-pro-es73132

  PRODUCT_LINE_PAGE: "PRODUCT_LINE_PAGE", // raybestos-specialty-line-brake-pads
  MAKE_MODEL_PRODUCT_LINE_PAGE: "MAKE_MODEL_PRODUCT_LINE_PAGE", // https://partsavatar.ca/toyota-4-runner-weathertech-black-floor-mat#FAQ
  LANDING: "LANDING_PAGE",
  CATEGORY_PAGE: "CATEGORY_PAGE",
  UNKNOWN_PAGE: "UNKNOWN_PAGE",
  TIER1_YEAR_MAKE_MODEL_PAGE: "TIER1_YEAR_MAKE_MODEL_PAGE",
  // MANUFACTURERS PAGE
  ALL_MANUFACTURERS_PAGE: "ALL_MANUFACTURERS_PAGE",
  MANUFACTURER_PAGE: "MANUFACTURER_PAGE",
  MANUFACTURER_TIER1_PAGE: "MANUFACTURER_TIER1_PAGE",
  MANUFACTURER_TIER2_PAGE: "MANUFACTURER_TIER2_PAGE", // https://partsavatar.ca/raybestos-brake-disc-rotors
};

export const LINE_PAGES = [
  "MAKE_MODEL_PRODUCT_LINE_PAGE",
  "PRODUCT_LINE_PAGE",
];

export const PAGE_TYPE_TO_RESPONSE_KEY = {
  [PAGE_TYPES.PRODUCT_FITMENT]: "productDetails",
  [PAGE_TYPES.LANDING]: "landingPage",
};

export const TIER_PAGES = [
  "TIER0_PAGE",
  "TIER1_PAGE", // axles-drivetrain-parts
  "TIER2_PAGE", // axleshaft-parts
  "TIER3_PAGE",
];

export const TIER_MAKE_PAGES = [
  "TIER1_MAKE_PAGE",
  "TIER2_MAKE_PAGE",
  "TIER3_MAKE_PAGE", // honda-rear-brake-rotor
];

export const TIER_MAKE_MODEL_PAGES = [
  "TIER0_MAKE_MODEL_PAGE",
  "TIER1_MAKE_MODEL_PAGE", // honda-civic-axles-drivetrain
  "TIER2_MAKE_MODEL_PAGE",
  "TIER3_MAKE_MODEL_PAGE",
];

export const FITMENT_TIER_PAGES = [
  "TIER0_YEAR_MAKE_MODEL_PAGE", // 1962-alfa-romeo-2000-replacement-parts => on prod only
  "TIER1_YEAR_MAKE_MODEL_PAGE", // 2014-acura-ilx-axles-drivetrain-parts
  "TIER2_YEAR_MAKE_MODEL_PAGE", // /2005-ford-focus-wheel-bearings
  "TIER3_YEAR_MAKE_MODEL_PAGE", // /2005-ford-focus-blower-motor-resistors
];

export const CATEGORY_PAGE_TYPES = [
  ...TIER_PAGES,
  ...FITMENT_TIER_PAGES,
  ...TIER_MAKE_MODEL_PAGES,
];

export const MANUFACTURER_TIER_PAGE = [
  PAGE_TYPES.MANUFACTURER_TIER1_PAGE,
  PAGE_TYPES.MANUFACTURER_TIER2_PAGE,
];

export const COLLECTION_PAGE_TYPES = [
  ...CATEGORY_PAGE_TYPES,
  ...MANUFACTURER_TIER_PAGE,
];

// page_type when we don't set vehicle in SSR
export const NON_VEHICLE_PAGE_TYPES = ["MAKE_PAGE", "MAKE_MODEL_PAGE", "TIER1_MAKE_PAGE", "TIER2_MAKE_PAGE", "TIER3_MAKE_PAGE"];

export const SEARCH_PAGE = "SEARCH_PAGE";
export const PRODUCT_PAGE_TYPES = ["PRODUCT_PAGE", "PRODUCT_FITMENT_PAGE", "PRODUCT_MAKE_MODEL_PAGE"];

export const SHOPPING_CART_PAGE = "SHOPPING_CART_PAGE";
export const ARTICLE_PAGE = "ARTICLE_PAGE";
export const ACCOUNT_PAGE = "ACCOUNT_PAGE";
export const CHECKOUT_PAGE = "CHECKOUT_PAGE";
export const TIRE_SIZE_PAGE = "TIRE_SIZE_PAGE";
export const ORDER_STATUS_PAGE = "ORDER_STATUS_PAGE";
export const RETURN_PAGE = "RETURN_PAGE";
export const LOGIN_PAGE = "LOGIN_PAGE";
